import { render, staticRenderFns } from "./EditWWCRole.vue?vue&type=template&id=5b774f87&"
import script from "./EditWWCRole.vue?vue&type=script&lang=js&"
export * from "./EditWWCRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports